import React, { useCallback } from 'react';
import { TFdrThGeoModuleObject } from 'components/domain/fdr-geo/fdr-geo.types';
import {
  createGeoBlogVariables,
  mapFdrGeoBlogResponseToArticles,
} from 'components/domain/fdr-geo/fdr-geo.utils';
import { NavigationIds } from 'components/domain/fdr-geo/navigation/fdr-geo-navigation.types';
import BlogArticleRecommendationsSection from 'components/domain/fdr-page-components/recommenders/blog-article/fdr-blog-recommender';
import useFdrPageComponentsFetch from 'components/domain/fdr-page-components/useFdrPageComponentsFetch';
import { FdrGeoBlogArticlesDocument } from 'schemas/query/geo/fdr-blog-articles.generated';

interface IFdrGeoBlogRecommenderProps {
  id: string;
  blogArticles: TFdrThGeoModuleObject['relatedBlogArticles'];
  title: string;
}

const FdrGeoBlogRecommender: React.FC<IFdrGeoBlogRecommenderProps> = ({
  id,
  blogArticles,
  title,
}) => {
  const mapVariables = useCallback(
    (page, perPage) => {
      return createGeoBlogVariables(id, page, perPage);
    },
    [id]
  );

  const { fetchItems } = useFdrPageComponentsFetch(
    FdrGeoBlogArticlesDocument,
    mapVariables,
    mapFdrGeoBlogResponseToArticles
  );

  return (
    <BlogArticleRecommendationsSection
      component={{
        id: NavigationIds.ARTICLES,
        title,
        blogArticleItems: blogArticles,
      }}
      fetchItems={fetchItems}
    />
  );
};

export default FdrGeoBlogRecommender;
